import React from 'react'
import { Field } from 'redux-form'
import { IconButton, Grid } from '@material-ui/core'
import { AddRounded } from '@material-ui/icons'
import { required } from 'services/validations'

import { Input } from 'components'

// TODO: Check if driver exist before adding
export const CreateDriverFormBase = ({ classes, handleSubmit }) => (
  <Grid
    container
    spacing={16}
    component='form'
    className={classes.container}
    alignItems='center'
  >

    <Grid item xs>
      <Field
        fullWidth
        name='label'
        label='ПІБ'
        margin='none'
        validate={required}
        component={Input}
      />
    </Grid>

    <Grid item>
      <IconButton onClick={handleSubmit}>
        <AddRounded fontSize='small' />
      </IconButton>
    </Grid>

  </Grid>
)



// WEBPACK FOOTER //
// ./src/components/Drivers/components/CreateDriverForm/CreateDriverForm.js